// Central config. Update app store links here once the apps are approved.
export const APP_DOWNLOAD = {
  ios: "#", // e.g. "https://apps.apple.com/app/idXXXXXXXX" — set when iOS is live
  android: "https://play.google.com/store/apps/details?id=com.emergent.jobsrestaurant.l8avqt",
};

export const BRAND = {
  name: "RestauranteJobs",
  domain: "restaurantejobs.com",
};

// Category chips shown on public listing (keys map to i18n labels)
export const CATEGORIES = [
  { key: "cook", match: ["cook", "cocina", "cocinero", "chef"] },
  { key: "waiter", match: ["waiter", "mesero", "server"] },
  { key: "dishwasher", match: ["dishwasher", "lavaplatos", "lavaloza"] },
  { key: "cashier", match: ["cashier", "cajero", "caja"] },
];
